import * as COS from 'cos-js-sdk-v5';
import { FileType, OssToken } from '../../model';
import { Injectable } from '@angular/core';
import { NecOssInterface } from './oss.interface';

@Injectable()
export class NecOssService {
  private ossToken: OssToken;
  private ossClient: COS;
  private multiUploadList: { [x: string]: { taskId: string, key: string, abort: boolean, file: File, stop: boolean; }; } = {};

  constructor(
    private ossInterface: NecOssInterface
  ) { }

  // è®¡ç®é¢è§çurl
  async signatureUrl(resId: string, key: string): Promise<string> {
    // è·åossClient
    await this.getOssTokenAndClientByResId(resId);

    return new Promise<string>((resolve, reject) => {
      this.ossClient.getObjectUrl({
        Bucket: this.ossToken.bucketName,
        Region: this.ossToken.region,     /* å­å¨æ¡¶æå¨å°åï¼å¿é¡»å­æ®µ */
        Key: '/' + key,
        Sign: true,
        Expires: 3600, // åä½ç§
      }, (err: COS.CosSdkError, data: COS.GetObjectUrlResult) => {
          if(err){
              reject(err.message);
          }
          if(data && data.Url){
              let url: string = data.Url.replace('http://'+this.ossToken.bucketName+'.cos.'+this.ossToken.region+'.myqcloud.com', this.ossToken.generalCdn || 'https://tymedia.512ks.cn');
              resolve(url);
          }
      });
    });
  }

  // ä¸ä¼ base64å½¢å¼çå¾ç
  async uploadBase64Image(base64Data: string, fileName: string, resId: string, tokenResId?: string): Promise<string> {
    // å¦ææªä¼ å¥tokenResId, åç´æ¥ä½¿ç¨resId
    if (!tokenResId) {
      tokenResId = resId;
    }

    // è·åossToken, ossClient
    await this.getOssTokenAndClientByResId(tokenResId);

    // è®¡ç®æä»¶ç±»åååç§°
    const key = this.createKey(resId, fileName, this.ossToken.environment);

    // ä¸ä¼ 
    return new Promise<string>((resolve, reject) => {
      this.ossClient.putObject({
        Bucket: this.ossToken.bucketName, /* å¿é¡» */
        Region: this.ossToken.region,     /* å­å¨æ¡¶æå¨å°åï¼å¿é¡»å­æ®µ */
        Key: '/' + key,              /* å¿é¡» */
        Body: this.dataURLtoBlob(base64Data), // ä¸ä¼ æä»¶å¯¹è±¡
        onProgress: (progressData) => {
        },
        onTaskReady: (taskId) => {
          resolve(key);
        },
      }, (err, data) => {
        if(data){
          resolve(key);
        }
        if(err){
          reject(err.message);
        }
      });
    });
  }

  // å°æä»¶ä¸ä¼ 
  async upload(file: File, resId: string, tokenResId?: string): Promise<string> {
    // å¦ææªä¼ å¥tokenResId, åç´æ¥ä½¿ç¨resId
    if (!tokenResId) {
      tokenResId = resId;
    }

    // è·åossToken, ossClient
    await this.getOssTokenAndClientByResId(tokenResId);

    // è®¡ç®æä»¶ç±»åååç§°
    const key = this.createKey(resId, file.name, this.ossToken.environment);

    // ä¸ä¼ 
    return new Promise<string>((resolve, reject) => {
      this.ossClient.putObject({
        Bucket: this.ossToken.bucketName, /* å¿é¡» */
        Region: this.ossToken.region,     /* å­å¨æ¡¶æå¨å°åï¼å¿é¡»å­æ®µ */
        Key: '/' + key,              /* å¿é¡» */
        Body: file, // ä¸ä¼ æä»¶å¯¹è±¡
        onProgress: (progressData) => {
        },
        onTaskReady: (taskId) => {
        },
      }, (err, data) => {
        if(data){
          resolve(key);
        }
        if(err){
          reject(err.message);
        }
      });
    });
  }

  // å¤§æä»¶åçä¸ä¼ 
  async multiPartUpload(file: File, resId: string, progress: Function, tokenResId?: string): Promise<string> {
    // å¦ææªä¼ å¥tokenResId, åç´æ¥ä½¿ç¨resId
    if (!tokenResId) {
      tokenResId = resId;
    }

    // è·åossToken, ossClient
    await this.getOssTokenAndClientByResId(tokenResId);

    // è®¡ç®æä»¶ç±»åååç§°
    const key = this.createKey(resId, file.name, this.ossToken.environment);

    // ä¸ä¼ 
    return new Promise<string>((resolve, reject) => {
      var uploadId = this.createUUID();
      this.multiUploadList[uploadId] = this.multiUploadList[uploadId] || {
          taskId: '',
          key: key,
          abort: false,
          file: file,
          stop: false
      };
      this.ossClient.sliceUploadFile({
          Bucket: this.ossToken.bucketName, // Bucket æ ¼å¼ï¼test-1250000000
          Region: this.ossToken.region,
          Key: '/' + key, /* å¿é¡» */
          Body: file,
          onTaskReady: (taskId) => {
            this.multiUploadList[uploadId].taskId = taskId;
          },
          onProgress: (progressData) => {
              if(progressData){
                  var data = {
                      loaded: progressData.loaded,
                      total: progressData.total,
                      progress: (progressData.percent * 100).toFixed(1),
                      speed: progressData.speed,
                      uploadId: uploadId,
                      key: key
                  };
                  progress(data)
              }
          }
      }, (err, data) => {
          if(data){
              delete this.multiUploadList[uploadId];
              resolve(key);
          }
          if(err){
            reject(err.message);
          }
      });

    });
  }

  // åæ¶åçä¸ä¼ 
  async abortMultipartUpload(resId: string, key: string, uploadId: string): Promise<any> {
    // è·åossToken, ossClient
    await this.getOssTokenAndClientByResId(resId);

    if (this.multiUploadList[uploadId]) {
      this.multiUploadList[uploadId].abort = true;
      this.ossClient.cancelTask(this.multiUploadList[uploadId].taskId);
    }
  }

  async stopMultiUpload(resId: string, key: string, uploadId: string) {
    await this.getOssTokenAndClientByResId(resId);

    if (this.multiUploadList[uploadId]) {
        this.multiUploadList[uploadId].stop = true;
        this.ossClient.pauseTask(this.multiUploadList[uploadId].taskId);
    }
  };

  async continueMultiUpload(resId: string, key: string, uploadId: string) {
    await this.getOssTokenAndClientByResId(resId);

    if (this.multiUploadList[uploadId]) {
        this.multiUploadList[uploadId].stop = true;
        this.ossClient.restartTask(this.multiUploadList[uploadId].taskId);
    }
  };


  // æ ¹æ®resIdè·åossTokenååå»ºå¯¹åºossClient
  private async getOssTokenAndClientByResId(resId: string) {
    // ä¼åä½¿ç¨ç¼å­çtoken
    // å¦æossTokenä¸å­å¨æèå·²è¿æ, å·æ°ossToken
    if (!this.ossToken || new Date(this.ossToken.credential.expiration).getTime() < new Date().getTime()) {
      this.ossToken = await this.ossInterface.getMediaOperationOssToken(resId).toPromise();
      this.ossClient = new COS({
        // å¿éåæ°
        getAuthorization: (options, callback) => {
            var credentials = this.ossToken && this.ossToken.credential && this.ossToken.credential.credentials;
            if (!this.ossToken || !credentials) {
                console.error('cosToken invalid')
            } else {
                callback({
                    TmpSecretId: credentials.tmpSecretId,
                    TmpSecretKey: credentials.tmpSecretKey,
                    SecurityToken: credentials.sessionToken,
                    // å»ºè®®è¿åæå¡å¨æ¶é´ä½ä¸ºç­¾åçå¼å§æ¶é´ï¼é¿åç¨æ·æµè§å¨æ¬å°æ¶é´åå·®è¿å¤§å¯¼è´ç­¾åéè¯¯
                    StartTime: this.ossToken.credential.startTime, // æ¶é´æ³ï¼åä½ç§ï¼å¦ï¼1580000000
                    ExpiredTime: this.ossToken.credential.expiredTime, // æ¶é´æ³ï¼åä½ç§ï¼å¦ï¼1580000900
                });
            }
        }
      });
    }
  }

  // åå»ºä¸ä¼ çkeyå¼
  private createKey(resId: string, filename: string, env: string) {
    const type = filename.substr(filename.lastIndexOf('.') + 1).toLowerCase();
    const uuid = this.createUUID();
    let prefix = env;
    if (FileType.isAudio(type)) {
      prefix += '/audio/';
    }
    else if (FileType.isVideo(type)) {
      prefix += '/video/';
    }
    else {
      prefix += '/other/';
    }

    return `${prefix}${resId.replace(':', '')}/${uuid}.${type}`;
  }

  // åå»ºä¸ä¸ªéæºæ è¯, ä½ä¸ºä¸ä¼ æä»¶çæä»¶å
  private createUUID() {
    let hexArray = [], hex = '0123456789abcdef';
    for (let i = 0; i < 32; i++) {
      hexArray[i] = hex.substr(Math.floor(Math.random() * 16), 1);
    }
    return hexArray.join('');
  }

  private dataURLtoBlob(dataUrl: string) {
    let arr = dataUrl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }
}
